export default __webpack_public_path__ + "static/media/Girdle of Heroic Soul.b0e254f2.jpg";